/* Swipeable image carousel inside the product tile — HEllO EDC

   The tile's large image becomes a track of the images for the colour that is
   currently selected on that tile, mirroring the product page: choose another
   swatch and the carousel shows that colour's photography instead.

   Which images belong to which colour comes from the alt text the store
   already keeps on most media — "Wild Lilac__Goat Suede Leather watch strap…".
   Products that never adopted that convention fall back to a plain list of
   their images, so every tile gets a carousel either way.

   A tile inside a row that itself scrolls sideways stays a single static
   image: two nested horizontal gestures read as one broken one.

   Testing the nudge: add ?wcnudge to the URL to replay it. */

(function () {
  if (window.__wcTileCarousel) return;   // the card snippet includes this once per card
  window.__wcTileCarousel = true;

  var NUDGE_KEY = 'wc-tile-nudged';
  var NUDGE_PX = 26;
  var MAX_SLIDES = 5;
  var FORCE_NUDGE = window.location.search.indexOf('wcnudge') > -1;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* A tile inside a horizontally scrolling row — Hot Right Now, product
     recommendations, any slider — must not scroll sideways itself. Detected
     from layout rather than from a list of section names, so it holds
     wherever the card is reused. */
  function insideHorizontalScroller(tile) {
    var el = tile.parentElement;
    while (el && el !== document.body) {
      var tag = el.tagName;
      if (tag === 'SLIDER-COMPONENT' || tag === 'SLIDESHOW-COMPONENT') return true;
      if (el.classList && (el.classList.contains('slider') || el.classList.contains('swiper'))) return true;
      var ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 4) return true;
      el = el.parentElement;
    }
    return false;
  }

  function imagesFor(tile, colour) {
    var el = tile.querySelector('[data-tile-images]');
    if (!el) return [];
    var map;
    try { map = JSON.parse(el.textContent); } catch (e) { return []; }
    if (!map) return [];

    /* Match on a normalised key so a stray space or a difference in casing
       between the swatch value and the alt-text prefix doesn't lose the set. */
    var want = String(colour == null ? '' : colour).trim().toLowerCase();
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] === '*') continue;
      if (keys[i].trim().toLowerCase() === want) return (map[keys[i]] || []).slice(0, MAX_SLIDES);
    }

    /* Nothing grouped to this colour — the product's ungrouped images. */
    return (map['*'] || []).slice(0, MAX_SLIDES);
  }

  /* ---------- building ---------- */

  function slideHTML(url, href, alt, eager) {
    return '<a class="wc-tile__slide" href="' + esc(href) + '" data-mosaic-title-link ' +
      'style="color:#3E3E3E;text-decoration:none;" tabindex="-1">' +
      '<img src="' + esc(url) + '" alt="' + esc(alt) + '" data-main-image="large" ' +
      'loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async">' +
      '</a>';
  }

  function collapse(track, url, link) {
    var first = track.querySelector('.wc-tile__slide');
    while (track.children.length > 1) track.removeChild(track.lastChild);
    if (!first) return;
    if (link) first.setAttribute('href', link);
    var img = first.querySelector('img');
    if (url && img && img.getAttribute('src') !== url) {
      img.removeAttribute('srcset');
      img.setAttribute('src', url);
    }
  }

  function build(tile, colour, href) {
    var track = tile.querySelector('[data-wc-track]');
    if (!track) return;

    var urls = imagesFor(tile, colour);
    var first = track.querySelector('.wc-tile__slide');
    var alt = (first && first.querySelector('img') && first.querySelector('img').alt) || '';
    var link = href || (first && first.getAttribute('href')) || tile.getAttribute('data-wc-url') || '';

    /* Static context, or nothing to page through: one image, no furniture. */
    if (tile.classList.contains('is-static') || urls.length < 2) {
      collapse(track, urls[0], link);
      tile.classList.remove('is-multi');
      paintDots(tile, 1, 0);
      return;
    }

    track.innerHTML = urls.map(function (u, i) {
      return slideHTML(u, link, alt, i === 0);
    }).join('');

    track.scrollLeft = 0;
    tile.classList.add('is-multi');
    paintDots(tile, urls.length, 0);
    paintArrows(tile);
  }

  function paintDots(tile, count, active) {
    var dots = tile.querySelector('[data-wc-dots]');
    if (!dots) return;
    if (count < 2) { dots.innerHTML = ''; return; }
    if (dots.children.length !== count) {
      var html = '';
      for (var i = 0; i < count; i++) html += '<span class="wc-tile__dot"></span>';
      dots.innerHTML = html;
    }
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].classList.toggle('is-on', j === active);
    }
  }

  function index(tile) {
    var track = tile.querySelector('[data-wc-track]');
    var slide = track && track.querySelector('.wc-tile__slide');
    if (!track || !slide) return 0;
    var w = slide.getBoundingClientRect().width || 1;
    return Math.round(track.scrollLeft / w);
  }

  function paintArrows(tile) {
    var track = tile.querySelector('[data-wc-track]');
    if (!track) return;
    var prev = tile.querySelector('[data-wc-prev]');
    var next = tile.querySelector('[data-wc-next]');
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function go(tile, dir) {
    var track = tile.querySelector('[data-wc-track]');
    var slide = track && track.querySelector('.wc-tile__slide');
    if (!track || !slide) return;
    var w = slide.getBoundingClientRect().width || track.clientWidth;
    track.scrollBy({ left: dir * w, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  /* ---------- the one-time nudge ----------

     The track IS the scrolling viewport, so transforming it would slide the
     whole window and reveal the tile's background rather than the next image.
     The nudge therefore drives scrollLeft itself, frame by frame: out to a
     sliver of image two, a brief hold, then back. */
  function nudge(tile) {
    if (reducedMotion()) return;
    var track = tile.querySelector('[data-wc-track]');
    if (!track || track.scrollLeft > 2) return;

    var OUT = 420, HOLD = 220, BACK = 460;
    var total = OUT + HOLD + BACK;
    var start = null;

    track.classList.add('is-nudging');

    var ease = function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };

    function frame(now) {
      if (start === null) start = now;
      var t = now - start;

      /* The shopper taking over mid-animation always wins. */
      if (track.__wcAbort) { finish(); return; }

      var x;
      if (t < OUT) x = NUDGE_PX * ease(t / OUT);
      else if (t < OUT + HOLD) x = NUDGE_PX;
      else if (t < total) x = NUDGE_PX * (1 - ease((t - OUT - HOLD) / BACK));
      else { finish(); return; }

      track.scrollLeft = x;
      requestAnimationFrame(frame);
    }

    function finish() {
      track.scrollLeft = 0;
      track.classList.remove('is-nudging');
      track.__wcAbort = false;
    }

    var abort = function () { track.__wcAbort = true; };
    track.addEventListener('touchstart', abort, { passive: true, once: true });
    track.addEventListener('pointerdown', abort, { passive: true, once: true });

    requestAnimationFrame(frame);
  }

  function armNudge() {
    if (!('IntersectionObserver' in window) || reducedMotion()) return;
    if (!FORCE_NUDGE) {
      try { if (sessionStorage.getItem(NUDGE_KEY)) return; } catch (e) { return; }
    }

    /* A low threshold on purpose: a tile can be taller than the viewport on a
       phone, and a high ratio would then never be reached — which is exactly
       how this failed to fire before. */
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (!e.isIntersecting) continue;
        if (!e.target.classList.contains('is-multi')) continue;
        if (e.target.classList.contains('is-static')) continue;
        try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (err) { /* private mode */ }
        setTimeout(function (t) { return function () { nudge(t); }; }(e.target), 450);
        io.disconnect();
        return;
      }
    }, { threshold: 0.2 });

    document.querySelectorAll('[data-wc-tile]').forEach(function (t) { io.observe(t); });
  }

  /* ---------- wiring ---------- */

  function initTile(tile) {
    if (tile.getAttribute('data-wc-ready')) return;
    tile.setAttribute('data-wc-ready', '1');

    if (insideHorizontalScroller(tile)) tile.classList.add('is-static');

    build(tile, tile.getAttribute('data-wc-colour'));

    if (tile.classList.contains('is-static')) return;

    var track = tile.querySelector('[data-wc-track]');
    if (track) {
      var t = null;
      track.addEventListener('scroll', function () {
        if (track.classList.contains('is-nudging')) return;
        if (t) return;
        t = setTimeout(function () {
          t = null;
          paintDots(tile, track.querySelectorAll('.wc-tile__slide').length, index(tile));
          paintArrows(tile);
        }, 80);
      }, { passive: true });
    }

    tile.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-wc-prev]');
      var next = e.target.closest('[data-wc-next]');
      if (!prev && !next) return;
      e.preventDefault();
      e.stopPropagation();
      go(tile, prev ? -1 : 1);
    });
  }

  /* A swatch click on the card re-points the carousel at that colour's
     photography, the same way the product page does. */
  function watchSwatches(card) {
    if (card.getAttribute('data-wc-swatch-bound')) return;
    card.setAttribute('data-wc-swatch-bound', '1');

    card.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var tile = card.querySelector('[data-wc-tile]');
      if (!tile) return;

      var colour = input.value;
      var variantId = input.getAttribute('data-variant-id');
      var url = input.getAttribute('data-product-url') || tile.getAttribute('data-wc-url') || '';
      var href = url && variantId
        ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId
        : url;

      tile.setAttribute('data-wc-colour', colour);
      build(tile, colour, href);
    });
  }

  function scan() {
    document.querySelectorAll('[data-wc-tile]').forEach(initTile);
    document.querySelectorAll('[data-product-mosaic-card]').forEach(watchSwatches);
  }

  function boot() {
    scan();
    armNudge();

    /* Collection filtering, pagination and section re-renders swap tiles in
       and out; pick up whatever arrives without re-running on our own edits. */
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; scan(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
